import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { request } from './request';

export const patch = <T, R = AxiosResponse<T>, D = unknown>(
  url: string,
  data?: D,
  config?: AxiosRequestConfig<D>,
) => request<T, R>({ method: 'patch', url, data, ...config });
